(function () {
	'use strict';

	angular
		.module('franchiser.routes')
		.config(routes);

	/** @ngInject */
	function routes($stateProvider, PATHS_FRANCHISER, SYSTEM_MODULES) {
		$stateProvider
			// APPLICATIONS
			.state('app.franchiser-applications-list', {
				title: 'Aplicações',
				url: '/franchiser/applications',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/applications/application-list.html`,
				controller: 'ApplicationsFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_APPLICATION,
				isRestricted: true
			})
			.state('app.franchiser-applications-new', {
				title: 'Aplicações',
				url: '/franchiser/applications/new',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/applications/application-form.html`,
				controller: 'ApplicationsFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_APPLICATION,
				isRestricted: true
			})
			.state('app.franchiser-applications-edit', {
				title: 'Aplicações',
				url: '/franchiser/applications/{applicationId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/applications/application-form.html`,
				controller: 'ApplicationsFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_APPLICATION,
				isRestricted: true
			})

			// COMPANIES
			.state('app.franchiser-companies', {
				title: 'Todas as Empresas',
				url: '/franchiser/companies',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/companies/company-list.html`,
				controller: 'CompanyListFranchiserController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})
			.state('app.franchiser-companies-new', {
				title: 'Nova Empresa',
				url: '/franchiser/companies/new',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/companies/company-form.html`,
				controller: 'CompanyFormFranchiserController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})
			.state('app.franchiser-companies-edit', {
				title: 'Editar Empresa',
				url: '/franchiser/companies/{companyId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/companies/company-form.html`,
				controller: 'CompanyFormFranchiserController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})
			.state('app.franchiser-companies-reopen', {
				title: 'Nova Empresa',
				url: '/franchiser/companies/reopen',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/companies/company-reopen.html`,
				controller: 'CompanyReopenFranchiserController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})

			// COMPANY ASSOCIATION HISTORY
			.state('app.franchiser-companies-association', {
				title: 'Histórico de Associados',
				url: '/franchiser/companies/association-history',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/companies/company-association-history-list.html`,
				controller: 'CompanyAssociationHistoryController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})

			// COMPANY STATUS
			.state('app.franchiser-company-status-list', {
				title: 'Status de Empresa',
				url: '/franchiser/companies/status',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/company-status/company-status-list.html`,
				controller: 'CompanyStatusFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})
			.state('app.franchiser-company-status-new', {
				title: 'Novo Status de Empresa',
				url: '/franchiser/companies/status/new',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/company-status/company-status-form.html`,
				controller: 'CompanyStatusFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})
			.state('app.franchiser-company-status-edit', {
				title: 'Visualizar Status de Empresa',
				url: '/franchiser/companies/status/{companyStatusId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/company-status/company-status-form.html`,
				controller: 'CompanyStatusFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})

			// COMPANY ECONOMIC GRUPO
			.state('app.franchiser-company-economic-groups-list', {
				title: 'Grupos Econômicos',
				url: '/franchiser/companies/economic-groups',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/company-economic-groups/company-economic-groups-list.html`,
				controller: 'CompanyEconomicGroupsFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})
			.state('app.franchiser-company-economic-groups-new', {
				title: 'Novo Grupo Econômico',
				url: '/franchiser/companies/economic-groups/new',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/company-economic-groups/company-economic-groups-form.html`,
				controller: 'CompanyEconomicGroupsFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})
			.state('app.franchiser-company-economic-groups-edit', {
				title: 'Visualizar Grupo Econômico',
				url: '/franchiser/companies/economic-groups/{companyEconomicGroupId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/company-economic-groups/company-economic-groups-form.html`,
				controller: 'CompanyEconomicGroupsFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})

			// COMPANY BATCH UPDATE
			.state('app.franchiser-company-batch-update', {
				title: 'Atualização em Lote',
				url: '/franchiser/companies/batch-update',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/company-batch-update/company-batch-update.html`,
				controller: 'CompanyBatchUpdateFranchiserController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})

			// PARAMETERS
			.state('app.franchiser-parameters-list', {
				title: 'Parâmetros',
				url: '/franchiser/companies/parameters',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/parameters/parameters-list.html`,
				controller: 'ParameterFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})

			// TIPOS DE CONSULTORES
			.state('app.franchiser-consultant-types-list', {
				title: 'Tipos de Consultores',
				url: '/franchiser/companies/consultant-types',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/consultant-types/consultant-types-list.html`,
				controller: 'ConsultantTypeFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})

			// PEOPLE
			.state('app.franchiser-people-list', {
				title: 'Buscar Pessoas',
				url: '/franchiser/people',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/people/people-list.html`,
				controller: 'PeopleFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_PEOPLE,
				isRestricted: true
			})
			.state('app.franchiser-people-associate', {
				title: 'Associar Pessoa',
				url: '/franchiser/people/associate',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/people/people-associate.html`,
				controller: 'PeopleFranchiserAssociateController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_PEOPLE,
				isRestricted: true
			})
			.state('app.franchiser-people-associate-franchisee', {
				title: 'Associar Franqueado',
				url: '/franchiser/people/associate/franchisee/{companyId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/people/people-associate.html`,
				controller: 'PeopleFranchiserAssociateController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_PEOPLE,
				isRestricted: true
			})
			.state('app.franchiser-people-edit', {
				title: 'Visualizar Pessoa',
				url: '/franchiser/people/{personId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/people/people-form.html`,
				controller: 'PeopleFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_PEOPLE,
				isRestricted: true
			})
			.state('app.franchiser-people-pre-register', {
				title: 'Associar Pessoa',
				url: '/franchiser/people/pre-registers',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/people/people-pre-register.html`,
				controller: 'PeopleFranchiserPreRegisterController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_PEOPLE,
				isRestricted: true
			})

			// REGIONAL
			.state('app.franchiser-regionals-list', {
				title: 'Regionais',
				url: '/franchiser/regionals',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/regionals/regional-list.html`,
				controller: 'RegionalFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_REGIONAL,
				isRestricted: true
			})
			.state('app.franchiser-regionals-new', {
				title: 'Nova Regional',
				url: '/franchiser/regionals/new',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/regionals/regional-form.html`,
				controller: 'RegionalFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_REGIONAL,
				isRestricted: true
			})
			.state('app.franchiser-regionals-edit', {
				title: 'Visualizar Regional',
				url: '/franchiser/regionals/{regionalId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/regionals/regional-form.html`,
				controller: 'RegionalFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_REGIONAL,
				isRestricted: true
			})

			// CATEGORY
			.state('app.franchiser-categories-list', {
				title: 'Categorias',
				url: '/franchiser/companies/categories',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/categories/category-list.html`,
				controller: 'CategoryFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})
			.state('app.franchiser-categories-new', {
				title: 'Nova Categoria',
				url: '/franchiser/companies/categories/new',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/categories/category-form.html`,
				controller: 'CategoryFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})
			.state('app.franchiser-categories-edit', {
				title: 'Visualizar Categoria',
				url: '/franchiser/companies/categories/{categoryId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/categories/category-form.html`,
				controller: 'CategoryFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_COMPANY,
				isRestricted: true
			})

			// PERMISSION GROUPS
			.state('app.franchiser-permission-groups-list', {
				title: 'Grupos de Permissão',
				url: '/franchiser/permission-groups',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/permission-groups/permission-group-list.html`,
				controller: 'PermissionGroupFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_PERMISSION_GROUP,
				isRestricted: true
			})
			.state('app.franchiser-permission-groups-new', {
				title: 'Novo Grupo de Permissão',
				url: '/franchiser/permission-groups/new',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/permission-groups/permission-group-form.html`,
				controller: 'PermissionGroupFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_PERMISSION_GROUP,
				isRestricted: true
			})
			.state('app.franchiser-permission-groups-edit', {
				title: 'Visualizar Grupo de Permissão',
				url: '/franchiser/permission-groups/{permissionGroupId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/permission-groups/permission-group-form.html`,
				controller: 'PermissionGroupFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_PERMISSION_GROUP,
				isRestricted: true
			})

			// CLUSTERS
			.state('app.franchiser-clusters-list', {
				title: 'Grupos de Empresa',
				url: '/franchiser/clusters',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/clusters/cluster-list.html`,
				controller: 'ClusterFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_CLUSTER,
				isRestricted: true
			})
			.state('app.franchiser-clusters-new', {
				title: 'Novo Grupo de Empresa',
				url: '/franchiser/clusters/new',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/clusters/cluster-form.html`,
				controller: 'ClusterFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_CLUSTER,
				isRestricted: true
			})
			.state('app.franchiser-clusters-edit', {
				title: 'Visualizar Grupo de Empresa',
				url: '/franchiser/clusters/{clusterId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/clusters/cluster-form.html`,
				controller: 'ClusterFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_CLUSTER,
				isRestricted: true
			})

			// RESPONSIBILITIES
			.state('app.franchiser-responsibilities-list', {
				title: 'Responsabilidades',
				url: '/franchiser/responsibilities',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/responsibilities/responsibility-list.html`,
				controller: 'ResponsibilityFranchiserListController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_RESPONSIBILITY,
				isRestricted: true
			})
			.state('app.franchiser-responsibilities-new', {
				title: 'Nova Responsabilidade',
				url: '/franchiser/responsibilities/new',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/responsibilities/responsibility-form.html`,
				controller: 'ResponsibilityFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_RESPONSIBILITY,
				isRestricted: true
			})
			.state('app.franchiser-responsibilities-edit', {
				title: 'Visualizar Responsabilidade',
				url: '/franchiser/responsibilities/{responsibilityId:int}',
				templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/responsibilities/responsibility-form.html`,
				controller: 'ResponsibilityFranchiserFormController',
				controllerAs: 'vm',
				moduleId: SYSTEM_MODULES.FRANCHISER_RESPONSIBILITY,
				isRestricted: true
			})
	}
}());